import JSGroupEventCodeSnippet from "../../../../contents/docs/_snippets/capture-group-event-code.mdx";
import * as React from 'react';
export default {
  JSGroupEventCodeSnippet,
  React
};